<div class="eui-chip-list-container">
    <div class="eui-chip-list-wrapper">
        <mat-chip-list
            #chipList
            #chipListDropList
            #chipListDragAndDropItems
            cdkDropList
            cdkDropListOrientation="horizontal"
            [cdkDropListDisabled]="!isChipsDragAndDrop"
            [cdkDropListData]="{ chips: chips }"
            [cdkDropListConnectedTo]="droppableArea"
            (cdkDropListDropped)="drop($event)"
            [attr.aria-label]="ariaLabel">
            <span
                *ngFor="let chip of chips; let i = index; trackBy: trackByFn"
                cdkDrag
                [cdkDragData]="chip"
                (cdkDragStarted)="onDragStarted($event)"
                (cdkDragReleased)="onDragReleased($event)">
                <eui-chip
                    *ngIf="(maxVisibleChipsCount && isMaxVisibleChipsOpened) || (maxVisibleChipsCount && maxVisibleChipsCount > i) || !maxVisibleChipsCount"
                    [data]="chip.data ? chip.data : chip"
                    [euiInternalId]="chip.euiInternalId"
                    [isChipRemovable]="chip.isChipRemovable || (isChipsRemovable && chip.isRemovable) !== false"
                    [euiOutline]="chip.euiOutline || euiOutline || chip.isOutline"
                    [euiSizeS]="chip.euiSizeS || euiSizeS || chip.sizeClass === 'euiSizeS'"
                    [euiSizeM]="chip.euiSizeM || euiSizeM || chip.sizeClass === 'euiSizeM'"
                    [euiSizeL]="chip.euiSizeL || euiSizeL || chip.sizeClass === 'euiSizeL'"
                    [euiSizeXL]="chip.euiSizeXL || euiSizeXL || chip.sizeClass === 'euiSizeXL'"
                    [euiSize2XL]="chip.euiSize2XL || euiSize2XL || chip.sizeClass === 'euiSize2XL'"
                    [euiRounded]="chip.euiRounded || euiRounded || chip.isRounded"
                    [euiDisabled]="chip.euiDisabled || euiDisabled || chip.isDisabled"
                    [euiPrimary]="chip.euiPrimary || euiPrimary || chip.typeClass === 'primary' || !chip.typeClass"
                    [euiSecondary]="chip.euiSecondary || euiSecondary || chip.typeClass === 'secondary'"
                    [euiInfo]="chip.euiInfo || euiInfo || chip.typeClass === 'info'"
                    [euiSuccess]="chip.euiSuccess || euiSuccess || chip.typeClass === 'success'"
                    [euiWarning]="chip.euiWarning || euiWarning || chip.typeClass === 'warning'"
                    [euiDanger]="chip.euiDanger || euiDanger || chip.typeClass === 'danger'"
                    [euiAccent]="chip.euiAccent || euiAccent || chip.typeClass === 'accent'"
                    [hasTooltip]="chip.hasTooltip"
                    [tooltipMessage]="chip.tooltipMessage"
                    (remove)="onRemove($event)">
                    <eui-icon *ngIf="chip.iconClass" [iconClass]="chip.iconClass"></eui-icon>
                    <span *ngIf="!chipsLabelTruncateCount" [innerHTML]="getChipContent(chip)"></span>
                    <span *ngIf="chipsLabelTruncateCount" title="{{ getChipLabel(chip) }}">{{ getChipLabel(chip) | euiTruncate: chipsLabelTruncateCount }}</span>
                </eui-chip>
            </span>
            <ng-content select="euiChipListAppendContent"></ng-content>
        </mat-chip-list>
    </div>
    <ng-container *ngIf="maxVisibleChipsCount && chips && chips.length > maxVisibleChipsCount">
        <div class="eui-chip-list__expand-button-wrapper">
            <button euiButton euiBasicButton euiButtonSecondary euiSizeS class="eui-chip-list__expand-button" (click)="toggleTags()" *ngIf="isMaxVisibleChipsOpened">
                <span euiIcon iconClass="eui-icon eui-icon-angle-left" aria-label="Collapse Icon"></span>
                <span euiLabel *ngIf="toggleLinkLessLabel" [attr.aria-label]="toggleLinkLessLabel | translate">{{ toggleLinkLessLabel | translate }}</span>
            </button>
            <button euiButton euiBasicButton euiButtonSecondary euiSizeS class="eui-chip-list__expand-button" (click)="toggleTags()" *ngIf="!isMaxVisibleChipsOpened">
                <span euiLabel *ngIf="toggleLinkMoreLabel" [attr.aria-label]="toggleLinkMoreLabel | translate">{{ toggleLinkMoreLabel | translate }}</span>
                <span euiIcon iconClass="eui-icon eui-icon-angle-right" aria-label="Expand Icon"></span>
            </button>
        </div>
    </ng-container>
</div>
